const PROP_TYPES_KEY = 'propTypes';
const types = (x) => (x || {})[PROP_TYPES_KEY];
const empty = (x) => !x || Object.keys(x).length === 0;

/**
 * Stip props from a set. ()
 *
 * @method restProps
 * @param  {Component|Function} T The Component that declares a static propTypes property
 * @param  {Object}  props Props in.
 * @return {Object} Props minus the props defined on T.propTypes
 */
export function restProps(T, { ...props } = {}) {
  const o = types(T);

  if (empty(o)) {
    console.warn('Type does not have PropTypes', T);
  }

  for (let prop of Object.keys(o || {})) {
    delete props[prop];
  }

  return props;
}

/**
 * Pluck props from a set. ()
 *
 * @method pluckProps
 * @param  {Component|Function} T The Component that declares a static propTypes property
 * @param  {Object}  props Props in.
 * @return {Object} Only the Props defined on T.propTypes
 */
export function pluckProps(T, blob) {
  const o = types(T);
  const props = {};

  if (empty(o)) {
    console.warn('Type does not have PropTypes', T);
  }

  for (let prop of Object.keys(o || {})) {
    if (prop in blob) {
      props[prop] = blob[prop];
    }
  }

  return props;
}
